/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="106.21"
        height="94.33"
        viewBox="0 0 106.21 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g>
          <path
            d="M122.46,65.65a1.27,1.27,0,0,1,1.67-.09l.1.09,6.12,6.12a1.27,1.27,0,0,1,.09,1.67l-.09.1-6,6a1.25,1.25,0,0,1-1.86-1.66l.09-.11,5.12-5.11-5.23-5.24a1.24,1.24,0,0,1-.09-1.67Z"
            transform="translate(-24.5 -29.5)"
            fill="#ffb81c"/>
          <path
            d="M128.94,71.41a1.25,1.25,0,0,1,.13,2.49H108.55a1.25,1.25,0,0,1-1.25-1.25,1.27,1.27,0,0,1,1.13-1.25h20.51Z"
            transform="translate(-24.5 -29.5)"
            fill="#ffb81c"/>
          <path
            d="M31,65.65a1.25,1.25,0,0,1,1.86,1.67l-.09.1-5.23,5.24,5.12,5.11a1.27,1.27,0,0,1,.09,1.67l-.09.1a1.24,1.24,0,0,1-1.67.09l-.1-.09-6-6a1.26,1.26,0,0,1-.1-1.67l.1-.1Z"
            transform="translate(-24.5 -29.5)"
            fill="#ffb81c"/>
          <path
            d="M46.66,71.41a1.25,1.25,0,0,1,.13,2.49H26.27a1.25,1.25,0,0,1-.13-2.5H46.66Z"
            transform="translate(-24.5 -29.5)"
            fill="#ffb81c"/>
        </g><path
          d="M115.85,101a1.26,1.26,0,0,1,1.25,1.12v8.78a1.24,1.24,0,0,1-1.12,1.24h-8.62a1.25,1.25,0,0,1-1.25-1.25,1.27,1.27,0,0,1,1.13-1.25h7.36v-7.4a1.27,1.27,0,0,1,1.13-1.25Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M100.19,95.26a1.23,1.23,0,0,1,1.66-.09l.1.09,14.42,14.42a1.25,1.25,0,0,1,0,1.77,1.27,1.27,0,0,1-1.67.09l-.1-.09L100.19,97A1.25,1.25,0,0,1,100.19,95.26Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M47.93,33.1a1.25,1.25,0,0,1,.13,2.49H40.53v7.24a1.25,1.25,0,0,1-1.13,1.24h-.12A1.26,1.26,0,0,1,38,43V34.35a1.24,1.24,0,0,1,1.12-1.24h8.78Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M38.76,33.83a1.25,1.25,0,0,1,1.66-.09l.11.09L54.94,48.25a1.25,1.25,0,0,1-1.66,1.86l-.1-.09L38.76,35.6A1.25,1.25,0,0,1,38.76,33.83Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M115.94,33.1a1.25,1.25,0,0,1,1.24,1.12v8.62a1.25,1.25,0,0,1-2.5.13V35.6h-7.4A1.25,1.25,0,0,1,106,34.48v-.13a1.24,1.24,0,0,1,1.13-1.24h8.78Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M114.69,33.83a1.25,1.25,0,0,1,1.85,1.67l-.09.1L102,50a1.25,1.25,0,0,1-1.86-1.67l.09-.1Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M39.36,101a1.25,1.25,0,0,1,1.24,1.12v7.53h7.24a1.25,1.25,0,0,1,1.24,1.12v.13A1.24,1.24,0,0,1,48,112.17H39.36a1.26,1.26,0,0,1-1.25-1.12v-8.78A1.24,1.24,0,0,1,39.36,101Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M53.26,95.26a1.25,1.25,0,0,1,1.77,0,1.27,1.27,0,0,1,.09,1.67L55,97,40.61,111.45a1.27,1.27,0,0,1-1.77,0,1.24,1.24,0,0,1-.09-1.67l.09-.1Z"
          transform="translate(-24.5 -29.5)"
          fill="#ffb81c"/><path
          d="M77.61,123.83v0Z"
          transform="translate(-24.5 -29.5)"
          fill="#0E497B"
          fillRule="evenodd"/><polygon
          points="54.36 82.94 54.35 94.33 51.85 94.33 51.86 82.94 54.36 82.94"
          fill="#0e497b"/><path
          d="M77.61,112.43v0Z"
          transform="translate(-24.5 -29.5)"
          fill="#0E497B"
          fillRule="evenodd"/><path
          d="M77.61,89.08a1.25,1.25,0,0,1,1.24,1.12v22.23a1.24,1.24,0,0,1-1.25,1.25,1.26,1.26,0,0,1-1.25-1.12V90.33A1.25,1.25,0,0,1,77.61,89.08Z"
          transform="translate(-24.5 -29.5)"
          fill="#0e497b"/><path
          d="M68.21,123.83v0Z"
          transform="translate(-24.5 -29.5)"
          fill="#0E497B"
          fillRule="evenodd"/><polygon
          points="44.96 82.94 44.96 94.33 42.46 94.33 42.46 82.94 44.96 82.94"
          fill="#0e497b"/><path
          d="M68.21,112.44v0Z"
          transform="translate(-24.5 -29.5)"
          fill="#0E497B"
          fillRule="evenodd"/><path
          d="M68.21,67.75a1.24,1.24,0,0,1,1.24,1.12v43.57a1.25,1.25,0,0,1-2.49.12V69A1.25,1.25,0,0,1,68.21,67.75Z"
          transform="translate(-24.5 -29.5)"
          fill="#0e497b"/><g>
          <path
            d="M84.72,52.33a11.4,11.4,0,0,1,11.4,11.1V88a3.9,3.9,0,0,1-3.69,3.68H87a1.25,1.25,0,0,1-.13-2.5h5.36a1.38,1.38,0,0,0,1.38-1.26V63.72A8.9,8.9,0,0,0,85,54.83H70.49a8.9,8.9,0,0,0-8.9,8.63V87.75a1.39,1.39,0,0,0,1.26,1.38h5.36a1.25,1.25,0,0,1,.13,2.49H63A3.89,3.89,0,0,1,59.1,88V63.72A11.41,11.41,0,0,1,70.2,52.33H84.72Z"
            transform="translate(-24.5 -29.5)"
            fill="#0e497b"/>
          <g>
            <line
              x1="62.5"
              y1="82.94"
              x2="62.5"
              y2="94.33"
              fill="none"/>
            <polygon
              points="63.75 82.94 63.75 94.33 61.25 94.33 61.25 82.94 63.75 82.94"
              fill="#0e497b"/>
          </g>
          <g>
            <line
              x1="62.5"
              y1="39.5"
              x2="62.5"
              y2="82.94"
              fill="none"/>
            <path
              d="M87,67.75a1.24,1.24,0,0,1,1.24,1.12v43.57a1.25,1.25,0,0,1-2.49.12V69A1.25,1.25,0,0,1,87,67.75Z"
              transform="translate(-24.5 -29.5)"
              fill="#0e497b"/>
          </g>
          <path
            d="M77.61,29.5a9.83,9.83,0,1,0,9.83,9.83A9.83,9.83,0,0,0,77.61,29.5Zm0,2.5a7.33,7.33,0,1,1-7.32,7.33A7.33,7.33,0,0,1,77.61,32Z"
            transform="translate(-24.5 -29.5)"
            fill="#0e497b"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'PersonOutwardArrowsIcon';

export default Icon;
